import React, { useState } from 'react';

import PropTypes from 'prop-types';

import 'slick-carousel/slick/slick.css';
// import Slider from 'react-slick';

import Section03SliderItem from '~/components/Section03SliderItem';

import ModalProject from '~/components/ModalProjetos';

import { Container, SliderContainer } from './styles';

import { loadProjects } from '~/services/api.projects';

export default function Section03Slider({ lineTo }) {
  // const sliders = loadProjects();
  const sliderFilter = loadProjects().filter(gender => {
    return gender.gender === lineTo;
  });

  // console.log(sliderFilter);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalSubTitle, setModalSubTitle] = useState('');
  const [modalText, setModalText] = useState('');
  const [modalObjective, setModalObjective] = useState('');
  const [modalexecutingUnit, setModalexecutingUnit] = useState('');
  const [modalcoordination, setModalcoordination] = useState('');
  const [modaltargetAudience, setModaltargetAudience] = useState('');
  const [modalglobalValue, setModalglobalValue] = useState('');
  const [modaltoSupport, setModaltoSupport] = useState('');
  const [modalregionalCoverage, setModalregionalCoverage] = useState('');
  const [modalduration, setModalduration] = useState('');

  // function alertProps(valor) {
  //   console.log(valor);
  //   setModalVisible(true);
  //   setModalTitle(valor);
  // }

  function setModalContents(
    title,
    subtitle,
    text,
    objective,
    executingUnit,
    coordination,
    targetAudience,
    globalValue,
    toSupport,
    regionalCoverage,
    duration
  ) {
    setModalVisible(true);
    setModalTitle(title);
    setModalSubTitle(subtitle);
    setModalText(text);
    setModalObjective(objective);
    setModalexecutingUnit(executingUnit);
    setModalcoordination(coordination);
    setModaltargetAudience(targetAudience);
    setModalglobalValue(globalValue);
    setModaltoSupport(toSupport);
    setModalregionalCoverage(regionalCoverage);
    setModalduration(duration);
  }

  function closeModal() {
    setModalVisible(false);
  }

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1366,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       },
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       },
  //     },
  //   ],
  // };

  return (
    <>
      <Container>
        {/* <Slider {...settings}> */}
        <SliderContainer>
          {sliderFilter.map(slider => (
            <Section03SliderItem
              clickFunction={() =>
                setModalContents(
                  slider.title,
                  slider.subtitle,
                  slider.text,
                  slider.objective,
                  slider.executingUnit,
                  slider.coordination,
                  slider.targetAudience,
                  slider.globalValue,
                  slider.toSupport,
                  slider.regionalCoverage,
                  slider.duration
                )
              }
              key={slider.id}
              title={slider.title}
              subtitle={slider.subtitle}
              text={slider.textIntro}
              link={slider.link}
              image={slider.image}
              toSupport={slider.toSupport}
            />
          ))}
        </SliderContainer>
        {/* {sliders.length === 3 ? (
            <Section03SliderItem
              clickFunction={() =>
                setModalContents(
                  sliders[0].title,
                  sliders[0].subtitle,
                  sliders[0].text,
                  sliders[0].objective,
                  sliders[0].executingUnit,
                  sliders[0].coordination,
                  sliders[0].targetAudience,
                  sliders[0].globalValue,
                  sliders[0].toSupport,
                  sliders[0].regionalCoverage,
                  sliders[0].duration
                )
              }
              key={sliders[0].id + 444}
              title={sliders[0].title}
              subtitle={sliders[0].subtitle}
              text={sliders[0].textIntro}
              link={sliders[0].link}
              image={sliders[0].image}
            />
          ) : (
            ''
          )} */}
        {/* </Slider> */}
      </Container>
      {modalVisible ? (
        <ModalProject
          closeModal={closeModal}
          title={modalTitle}
          subtitle={modalSubTitle}
          text={modalText}
          objective={modalObjective}
          executingUnit={modalexecutingUnit}
          coordination={modalcoordination}
          targetAudience={modaltargetAudience}		  
          globalValue={modalglobalValue}
          toSupport={modaltoSupport}
          regionalCoverage={modalregionalCoverage}
          duration={modalduration}
          // title={sliders[0].title}
          // subtitle={sliders[0].subtitle}
          // text={sliders[0].text}
          // objective={sliders[0].objective}
          // executingUnit={sliders[0].executingUnit}
          // coordination={sliders[0].coordination}
          // targetAudience={sliders[0].targetAudience}
          // globalValue={sliders[0].globalValue}
          // duration={sliders[0].duration}
        />
      ) : (
        ''
      )}
    </>
  );
}
Section03Slider.propTypes = {
  lineTo: PropTypes.string,
};
